import '../styles/footer.scss';

export function Footer() {
    return (
      <div id="footer">
        <p>Made with ❤ by Maikelen Salles</p>
      </div>
    )
}